export enum ERequestPaymentType {
  STANDARD = 'STANDARD',
  PHASED = 'PHASED',
  PHASED_PREPAID = 'PHASED_PREPAID',
}
